import { useQuery } from '@tanstack/react-query';
import { jobApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useJobSummary(jobId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.jobs.summary(jobId ?? -1),
    queryFn: ({ signal }) =>
      jobApiClient.getJobSummary(jobId!, toCancelToken(signal)),
    enabled: jobId != null && jobId > 0,
    staleTime: 0,
    meta: { errorContext: 'job summary' },
  });
}
